// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  strings: {},
  language: 'en',
  stringsLoaded: false,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
